export default "__VITE_ASSET__CSz84h8Q__"